//这里面是共通的接口
//引入axios配置文件
import http from "./config";
// let baseUrl = process.env.EVN_CONFIG
//设置一个接口对象
let getData = {};
//模板
getData.login = data => {
  return http.post("/login", data);
};

//获取文章列表
getData.get_web_list = data => {
  return http.get("/apis/website/admin_website/web_list", {
    params: data
  });
  // return http.get("website/admin_website/web_list", {
  //   params: data
  // });
};

//获取文章详情
getData.get_web_info = data => {
  return http.get(`/apis/website/admin_website/web_info/${data}`);
  // return http.get(`website/admin_website/web_info/${data}`);
};
//暴露出这个接口对象
export default getData;



// WEBPACK FOOTER //
// ./src/util/api.js